import React from 'react'
import ContentCaseStudy from '../../../components/ContentCaseStudy'

const CaseStudyWidget = (props) => {
  return (
    <>
      {props.caseStudies &&
        props.caseStudies.length &&
        props.caseStudies.map((caseStudy, i) => {
          const order = i % 2 === 0 ? 0 : 1
          return (
            <ContentCaseStudy
              order={order}
              key={`caseStudy-${i}`}
              {...caseStudy}
            />
          )
        })}
    </>
  )
}

export default CaseStudyWidget
